import { Divider } from '@mantine/core'
import {
  IconAffiliate,
  IconBox,
  IconBuilding,
  IconExternalLink,
  IconFolders,
  IconRobot,
  IconRocket,
  IconRouter,
  IconUsersGroup,
  IconVideo
} from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import {
  ExternalNavLink,
  NavLink
} from '@/components/ui-shared/NavLink/NavLink'
import { DEV_VLM_PIPELINES_ENABLED, VP_DOCS_URL } from '@/config/main'
import { useHasPermissions } from '@/permissions/useHasPermissions'
import { RouterPath } from '@/router/paths'
import { CrudAction, Resource } from '@/types/permissions'

export const HomeNavLinks = () => {
  const [canAccessVlm] = useHasPermissions(Resource.VlmPipelines, [
    CrudAction.Read
  ])

  const [canAccessCrossCamera] = useHasPermissions(Resource.Applications, [
    CrudAction.Read
  ])

  const showVlm = DEV_VLM_PIPELINES_ENABLED || canAccessVlm

  return (
    <>
      <NavLink
        to={RouterPath.apps}
        icon={<IconBox />}
        label={<FormattedMessage id="navLinks.applications" />}
      />

      <NavLink
        to={RouterPath.datasets}
        icon={<IconFolders />}
        label={<FormattedMessage id="navLinks.datasets" />}
      />

      <Divider my="xs" />

      <NavLink
        to={RouterPath.devices}
        icon={<IconRouter />}
        label={<FormattedMessage id="navLinks.devices" />}
      />

      <NavLink
        to={RouterPath.cameras}
        icon={<IconVideo />}
        label={<FormattedMessage id="navLinks.cameras" />}
      />

      {canAccessCrossCamera && (
        <NavLink
          to={RouterPath.crossCamera}
          icon={<IconUsersGroup />}
          label={<FormattedMessage id="navLinks.crossCamera" />}
        />
      )}

      <NavLink
        to={RouterPath.aiBridge}
        icon={<IconAffiliate />}
        label={<FormattedMessage id="navLinks.aiBridge" />}
      />

      <NavLink
        to={RouterPath.deployments}
        icon={<IconRocket />}
        label={<FormattedMessage id="navLinks.deployments" />}
      />

      {showVlm && (
        <NavLink
          to={RouterPath.vlm}
          icon={<IconRobot />}
          label={<FormattedMessage id="navLinks.vlm" />}
        />
      )}

      <NavLink
        to={RouterPath.tower}
        icon={<IconBuilding />}
        label={<FormattedMessage id="navLinks.tower" />}
      />

      <Divider my="xs" />

      <ExternalNavLink
        href={VP_DOCS_URL}
        icon={<IconExternalLink />}
        label={<FormattedMessage id="navLinks.documentation" />}
      />
    </>
  )
}
